import {fetchAudioActionSuccess, saveBGSoundID, saveEffectsSoundID} from "modules/actions/audio";
import {createReducer} from 'redux-act';


export interface IBackground {
	src: string;
}

export interface IScreen {
	trivia_schedule: number[];
}

export type AudioSpriteType =  [number, number] | [number, number, boolean];

export interface IAudioSprite {
	src: string;
	sprite: Record<string, AudioSpriteType>;
}

export interface IAudio {
	background_common: IBackground;
	audio_sprite: IAudioSprite;
}

const defaultAudioJSON: IAudio = {
	background_common: {
		src: ""
	},
	audio_sprite: {
		src: '',
		sprite: {}
	}
};

const defaultState = {
	settings: defaultAudioJSON,
	background_sound_id: 0,
	sound_effect_id: 0,
	is_fetched: false
}

export type TAudioStore = typeof defaultState;

export const audio_trivia = createReducer<TAudioStore>({}, defaultState)
	.on(fetchAudioActionSuccess, (state, payload) => ( {
		...state,
		settings: payload,
		is_fetched: true
	} ))
	.on(saveBGSoundID, (state, payload) => ( {
		...state,
		background_sound_id: payload
	} ))
	.on(saveEffectsSoundID, (state, payload) => ( {
		...state,
		sound_effect_id: payload
	} ))
;
